import React from 'react';
import { useFm, useScreenType } from '@web3/base-hooks';
import { Collapse, TextLink } from '@bfe/moly';
import clx from 'classnames';
import styles from './index.module.scss';
import {
  TOTAL_REWARD_AMOUNT,
  DAILY_REWARD_AMOUNT,
  GRANT_REWARD_BASE,
  GRANT_REWARD_PERSONAL_TOP,
  SINGLE_LIMIT,
  DOUBLE_LIMIT,
  TOP_SUPPORTERS_SHARE,
} from '@/utils/constant';

const FAQ = () => {
  const fm = useFm();
  const { isMobile } = useScreenType();

  const content = (text) => (
    <span
      className={styles.content}
      dangerouslySetInnerHTML={{ __html: text }}
    />
  );
  const items = [
    {
      label: fm('faqWhatIsAiDolSuperstar'),
      key: 1,
      children: content(
        fm('faqWhatIsAiDolSuperstarDesc', {
          amount: TOTAL_REWARD_AMOUNT,
        })
      ),
    },
    {
      label: fm('faqEarnRewardsQuery'),
      key: 2,
      children: (
        <>
          {content(fm('winPrizeChance'))}
          {
            <ul
              className={clx([
                styles.discList,
                styles.noPadding,
                {
                  'mb-[12px]': !isMobile,
                  'mb-[4px]': isMobile,
                },
              ])}
            >
              <li>
                <span>{fm('grandPrizePool2')}</span>
                <ul className={styles.discList}>
                  <li>
                    <span>
                      {fm('leaderboardRewardsInfo', {
                        amount1: GRANT_REWARD_BASE,
                        amount2: GRANT_REWARD_PERSONAL_TOP,
                      })}
                    </span>
                    <ul className={styles.romanList}>
                      <li>
                        {fm('topSupportersShareAmount1', {
                          amount1: TOP_SUPPORTERS_SHARE.FISRT.amount1,
                          amount2: TOP_SUPPORTERS_SHARE.FISRT.amount2,
                        })}
                      </li>
                      <li>
                        {fm('topSupportersShareAmount2', {
                          amount1: TOP_SUPPORTERS_SHARE.SECOND.amount1,
                          amount2: TOP_SUPPORTERS_SHARE.SECOND.amount2,
                        })}
                      </li>
                      <li>
                        {fm('topSupportersShareThirdProject3', {
                          amount1: TOP_SUPPORTERS_SHARE.THIRD.amount1,
                          amount2: TOP_SUPPORTERS_SHARE.THIRD.amount2,
                        })}
                      </li>
                      <li>
                        {fm('topSupportersShareAmount4', {
                          amount1: TOP_SUPPORTERS_SHARE.FORTH.amount1,
                          amount2: TOP_SUPPORTERS_SHARE.FORTH.amount2,
                        })}
                      </li>
                    </ul>
                  </li>
                  <li>
                    <span>
                      {fm('sunshineRewardsClaimNote', {
                        amount1: '10,000',
                        amount2: DAILY_REWARD_AMOUNT,
                      })}
                    </span>
                  </li>
                </ul>
              </li>
              <li>
                <span>{fm('dailyLuckyDrawTaskVoteWinRewards')}</span>
                <ul className={styles.discList}>
                  <li>
                    <span>{fm('voteLuckyDrawChance')}</span>
                  </li>
                  <li>
                    <span>{fm('dailyLuckyDrawRules')}</span>
                  </li>
                </ul>
              </li>
              <li>
                <span>{fm('minPointsForRewardsRequirement')}</span>
              </li>
            </ul>
          }
          {
            <TextLink
              variant="primary"
              color="#83F6F9"
              size={isMobile ? 'small' : 'normal'}
              onClick={() => {
                window.open(
                  'https://learn.bybit.com/ai/how-to-join-bybit-aidol/',
                  '_blank'
                );
              }}
            >
              {fm('learnMore')}
            </TextLink>
          }
        </>
      ),
    },
    {
      label: fm('aiProjectRankingInAIDolSuperstar'),
      key: 3,
      children: (
        <>
          {content(fm('aiProjectVotingPointUpdate'))}
          {content(`1. ${fm('supportersVoteDailyRule')}`)}
          {content(`2. ${fm('socialMediaBonusInfoRule')}`)}
          {content(`3. ${fm('mentorGrantBonusPoints')}`)}
        </>
      ),
    },
    {
      label: fm('howEarnVotingPoints'),
      key: 4,
      children: (
        <>
          {content(fm('faqEarnRewardsQueryDesc1'))}
          <ul className={clx([styles.discList, styles.noPadding])}>
            <li>
              <span>{fm('tradeMoreEarnMorePoints')}</span>
            </li>
            <li>
              <span>{fm('holdBbSolPointsRule')}</span>
            </li>
          </ul>
          {content(fm('votingPointLimitsRule'))}
          <ul className={clx([styles.discList, styles.noPadding])}>
            <li>
              <span>
                {fm('dailyVotingPointsLimit', {
                  amount: SINGLE_LIMIT,
                })}
              </span>
            </li>
            <li>
              <span>
                {fm('dailyVotingPointsLimit2', {
                  amount: SINGLE_LIMIT,
                })}
              </span>
            </li>
            <li>
              <span>
                {fm('participantTotalDailyVotingPointsLimit', {
                  amount: DOUBLE_LIMIT,
                })}
              </span>
            </li>
          </ul>
          {content(fm('excludeZeroFeeTradeAndUpdateDataHourly'))}
        </>
      ),
    },
    {
      label: fm('whenReceiveRewardsInfo'),
      key: 5,
      children: (
        <>
          {content(fm('distributeRewardsAfterEventEnds'))}
          <ul className={clx([styles.discList, styles.noPadding])}>
            <li>
              <span>{fm('registerEventRewardNote1')}</span>
            </li>
            <li>
              <span>{fm('registerEventRewardNote2')}</span>
            </li>
          </ul>
        </>
      ),
    },
    {
      label: fm('canVoteMultipleAiProjects'),
      key: 6,
      children: content(fm('allocateVotingPointsTip')),
    },
  ];
  return (
    <div className={styles.row}>
      <div className={styles.title}>{fm('faq')}</div>
      <Collapse items={items} collapsible={true} defaultValue={1} />
    </div>
  );
};

export default FAQ;
